import ContractAPI from '@/api/power-cable-portal/contract'
const state = {
  info: {}
}

const mutations = {
  SET_CONTRACT_INFO(state, info) {
    state.info = info
  }
}

const actions = {
  async getContractInfo({commit}) {
    let result = await ContractAPI.getContractAuthInfo()
    if (result.code == 0) {
      commit('SET_CONTRACT_INFO', result.data)
    }
    return result
  }
}

const getters = {
  info(state) {
    return state.info
  },
  isOpen(state) {
    return state.info.status == 12
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}